<template>
	<div class="app">
		<Header
			:variant="toolbarVariant"
			:event-label="eventHeaderLabel"
			:show-logo="showBlumarLogo"
			@open-menu="isMenuOpen = true"
		/>
		<Navbar :open="isMenuOpen" @close="isMenuOpen = false"/>
		<div class="app__content">
			<router-view></router-view>
		</div>
		<Footer :event="activeEvent"/>
		<CookieConsent/>
	</div>
</template>

<script>
import { translate } from './assets/translations';
import CookieConsent from './components/shared/CookieConsent.vue'
import Header from './components/shared/header/Header.vue';
import Navbar from './components/shared/header/Navbar.vue';
import Footer from './components/shared/Footer.vue';

export default {
	components: { CookieConsent, Header, Navbar, Footer },
	data() {
		return {
			isMenuOpen: false,
		};
	},
	computed: {
		translation() {
			return translate(this.$store.state.language).head;
		},
		toolbarVariant() {
			return this.$route.meta.toolbarVariant || 'solid';
		},
		activeEvent() {
			const event = this.$store.state.event;
			if (!event) return null;

			if (this.$route.name === 'clients-area') return event;
			if (!this.$route.meta.eventHeader) return null;

			const shortName = this.$route.params.shortName;
			return !shortName || event.shortName === shortName ? event : null;
		},
		showBlumarLogo() {
			return !this.activeEvent || this.activeEvent.showBlumarLogo !== false;
		},
		eventHeaderLabel() {
			if (!this.$route.meta.eventHeader || !this.activeEvent || !this.activeEvent.showOfficialAgencyTitle) return '';
			return translate(this.$store.state.language).eventHeader.officialAgency;
		},
	},
	watch: {
		'$route'() {
			this.isMenuOpen = false;
		},
	},
  metaInfo() {
		return {
			title: this.translation.title,
			meta: [
				{
					name:'description',
					content: this.translation.description
				},
				{
					name:'keywords',
					content: this.translation.keywords
				},
				{
					property: 'og:description',
					content: this.translation.ogDescription
				},
				{
					property: 'og:type',
					content: 'website'
				},
				{
					property: 'og:title',
					content: ' Blumar eventos –  - '
				},
			],
		}
	},
};
</script>

<style lang="scss">
@import "./bootstrap-theming.scss";
@import "./new-layout.scss";
.app {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
}

.app__content {
	flex: 1 0 auto;
}

body {
	margin: 0;
	font-family: 'Roboto', 'Lucida Sans Unicode', 'Arial', 'Helvetica', sans-serif;
	color: #253b6d;
}

button,
input,
select,
textarea {
	font-family: inherit;
}
ul {
	list-style-type: none;
	margin: 0;
	padding: 0;
}

.grey-btn {
  width: auto;
  background: #eee;
	font-weight: bold;
  color: #22b0a0;
  border: none;
  box-shadow: 0px 1px 2px #ccc;
  padding: 5px 10px;
  cursor: pointer;
}

.green-btn {
    display: block;
		width: fit-content;
		margin-top: 10px;
		margin-left: auto;
		border: none;
		background: #22b0a0;
		color: white;
		padding: 5px 10px;
		box-shadow: 0px 2px 4px #ccc;
		cursor: pointer;
}

a {
	text-decoration: none;
	color: inherit;
}
a:hover {
	color: #42bc97;
}
.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}
.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}
.slide-enter-to, .slide-leave {
  max-height: 500px;
  overflow: hidden;
}
.slide-enter, .slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

.red{
	color: red;
}

.event-tooltip {
	color: #fff;
	background-color: #17a2b8;
	margin-bottom: 3px;
	border-radius: 10%;
  font-size: 15px;
	padding: 2px;
	opacity: 0.7;
}

.event-tooltip:after {
    content:'';
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 0;
    height: 0;
    border-top: 8px solid #17a2b8;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
}
</style>



// WEBPACK FOOTER //
// src/App.vue